import DisplayText from '@sdk/components/ui/DisplayText';
import styled from 'styled-components';

export const POSSystemsScreenContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const POSSystemsContainer = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(4, minmax(auto, 205px));
  grid-template-rows: repeat(3, 72px);
`;

type POSItemProps = {
  isSelected?: boolean;
};
export const POSItem = styled.div<POSItemProps>`
  cursor: pointer;
  flex-grow: 1;
  display: flex;
  border-radius: 4px;
  background-color: ${({ theme: { colors }, isSelected }) =>
    isSelected ? `${colors.primary}05` : colors.white};
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid transparent;
  border-color: ${(props) => (props.isSelected ? props.theme.colors.primary : 'transparent')};

  &:hover {
    background-color: ${(props) => props.theme.colors.primary}05;
  }
`;

export const SkipSelectBtn = styled(DisplayText)`
  cursor: pointer;
  opacity: 0.65;
  text-decoration: underline;
`;

export const POSActionsContainer = styled.div`
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  width: 205px;
`;
